import { AuthProviderProps } from 'react-oidc-context';
import { User } from 'oidc-client-ts';

export const ROUTES = {
  login: '/login',
  home: '/construction',
  unauthorized: '/unauthorized',
} as const;

// 環境変数の存在チェック
const validateConfig = () => {
  const requiredEnvVars = [
    'REACT_APP_COGNITO_AUTHORITY',
    'REACT_APP_COGNITO_CLIENT_ID',
    'REACT_APP_COGNITO_REDIRECT_URI'
  ];
  const missing = requiredEnvVars.filter(key => !process.env[key]);
  
  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }
};

validateConfig();